import { render, staticRenderFns } from "./AppButton.vue?vue&type=template&id=59d031ee&scoped=true&"
import script from "./AppButton.vue?vue&type=script&lang=ts&"
export * from "./AppButton.vue?vue&type=script&lang=ts&"
import style0 from "./AppButton.vue?vue&type=style&index=0&id=59d031ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d031ee",
  null
  
)

export default component.exports